import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {ENUM_REDUCER_STATE_ID} from './enum_constants';
import {EnumMap} from './enum_types';

export interface EnumState {
  enumMap: EnumMap;
  isInitialized: Record<string, boolean>;
}

const initialState: EnumState = {
  enumMap: {},
  isInitialized: {},
};

export interface AddEnumsPayload {
  enumMap: EnumMap;
  id: string;
}

export const enumSlice = createSlice({
  name: ENUM_REDUCER_STATE_ID,
  initialState,
  reducers: {
    addEnums: (state, action: PayloadAction<AddEnumsPayload>) => {
      state.enumMap = {...state.enumMap, ...action.payload.enumMap};
      state.isInitialized[action.payload.id] = true;
    },
  },
});
